import React from "react";
import styled from "styled-components";
import {BlueButton} from "./ButtonStyles";

const AddButtonFullText = ({
                       id,
                       setId,
                       setUpdate,
                       title = "Ajouter"
                   }) => {

    const init = () => {
        if (id){
            if (typeof id === 'object') {
                setId([0])
            } else {
                setId(0)
            }
        }
        setUpdate(true, id = 0)
    }

    return (
        <Button
            onClick={init}
            className={'add-btn'}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#FAFAFA">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"/>
            </svg>
            <p className={"title-add-btn"}> {title} </p>
        </Button>
    )
}

const Button = styled(BlueButton)`
  padding: 1em 0;
  height: 2.2em;
  min-width: 10rem;
  max-width: 200px;
  align-self: center;
  
  &:hover {
    justify-content: center;
    svg{
      fill: var(--color-blue);
    }
  }
`

export default AddButtonFullText;